import React from 'react';
import PropTypes from 'prop-types';

import { getElementTemplateExampleLink } from '../../../../common/templates/templateUtil';

import './BoardTemplatePickerPublicParentPopup.scss';

const BoardTemplatePickerPublicParentPopup = ({ currentBoard }) => (
    <div className="BoardTemplatePickerPublicParentPopup BoardTemplatePickerPopup">
        <div className="picker-content">
            <h3>Public template</h3>

            <label>Template id (for Prismic):</label>
            <input className="FormInput template-id" value={getElementTemplateExampleLink(currentBoard)} readOnly />
        </div>
    </div>
);

BoardTemplatePickerPublicParentPopup.propTypes = {
    currentBoard: PropTypes.object,
};

export default BoardTemplatePickerPublicParentPopup;
